const mergeCategoriesNumbers = (
  usersCategories,
  numberInputs,
  startingDate
) => {
  const formatStartDate = new Date(startingDate);

  formatStartDate.setUTCDate(1);
  formatStartDate.setUTCHours(23, 59, 0, 0);

  return usersCategories.map((category, index) => {
    const numbersWithTimestamps = numberInputs[index].reduce((acc, num, i) => {
      const currentDate = new Date(formatStartDate.getTime());
      currentDate.setUTCMonth(formatStartDate.getUTCMonth() + i);

      const timestamp = currentDate.getTime();

      acc[timestamp] = num;

      return acc;
    }, {});

    return {
      ...category,
      numberInputs: numbersWithTimestamps,
    };
  });
};

export default mergeCategoriesNumbers;
